import jsxElem from "jsx-no-react";

const InfoBox = ({ message = '', link, label = 'Click here', target = '_self', style = {}, contentClass = '' }) => (
    <div class='bmui-info-box' style={style}>
        <div class='bmui-info-box-icon'>
            <i class="fa-light fa-lightbulb-on"></i>
        </div>
        <div class={`bmui-info-box-content${contentClass ? ' ' + contentClass : ''}`}>
            {message} {link && (<a href={link} target={target}>{label}</a>)}
        </div>
    </div>
);

export {
    InfoBox
};